<template>
  <div class="container">
    <main-title :arrowClick="false">
      <template v-slot:rightBtn>
        <img src="~images/video/icon-fh.png" class="imggs" @click="fhClick()" />
      </template>
    </main-title>
    <videos :index="index" />
  </div>
</template>

<script>
import mainTitle from "./components/mainTitle.vue";
const videos = () => import("./video/index");
export default {
  components: { mainTitle, videos },
  data() {
    return {
      index: 0
    };
  },
  created() {
    if (Object.prototype.hasOwnProperty.call(this.$route.query, "index")) {
      this.index = Number(this.$route.query.index);
    }
  },
  methods: {
    fhClick() {
      this.$router.back(-1);
    }
  }
};
</script>

<style lang="stylus" scoped>
.container
  width 100%
  height 100vh
  background url('~images/bg.png') no-repeat center
  background-size 100% 100%
  position relative
  overflow hidden
.imggs
  height 0.14rem
  position absolute
  bottom -0.02rem
  right 0.05rem
  cursor pointer
@media (max-width 1280px)
  .imggs
    height 0.22rem
    bottom 0.07rem
    right 0.08rem
    padding 3px 10px
    z-index 999
</style>
